import NoteContainer from "./NoteContainer";
import { useLanguage } from "../../lib/LanguageContext";
import { genericTranslate } from "../../lib/funcs";

function TermsOfUse() {
  const { languageData } = useLanguage();
  return (
    <NoteContainer title={genericTranslate(languageData, "Terms of Use")}>
      <p>{genericTranslate(languageData, "By using this app, you agree to the following terms:")}</p>

      <p><strong>{genericTranslate(languageData, "Free App with Ads:")}</strong> {genericTranslate(languageData, "This app is free to use but includes advertising.")}</p>

      <p><strong>{genericTranslate(languageData, "No Warranty:")}</strong>  {genericTranslate(languageData, "The app is provided \"as-is\" and without warranties of any kind. We disclaim all warranties, express or implied, including accuracy, completeness, or fitness for a particular purpose.")}</p>
      
      <p><strong>{genericTranslate(languageData, "Limitation of Liability:")}</strong> {genericTranslate(languageData, "We are not liable for any damages arising from app use, including data loss, errors, or financial losses.")}</p>

      <p><strong>{genericTranslate(languageData, "Your Use:")}</strong> {genericTranslate(languageData, "You agree to use the app responsibly and in accordance with all applicable laws.")}</p>

      <p><strong>{genericTranslate(languageData, "Termination:")}</strong> {genericTranslate(languageData, "We reserve the right to terminate your access to the app for any reason.")}</p>

      {/* <h6>{genericTranslate(languageData, "Governing Law")}</h6>
      <p>{genericTranslate(languageData, "These Terms shall be governed by and defined following the laws of Italy. Forex Calculators and yourself irrevocably consent that the courts of Italy shall have exclusive jurisdiction to resolve any dispute which may arise in connection with these terms.")}</p> */}
      
      <h6>{genericTranslate(languageData, "Changes to Terms:")}</h6>
      <p>{genericTranslate(languageData, "We may update these terms at any time. By continuing to use the app, you agree to any revisions.")}</p>

      <h6>{genericTranslate(languageData, "Contact Us")}</h6>
      <p>{genericTranslate(languageData, "If a term does not make sense to you, let us know please:")} <a href="mailto:android@forexcalcs.com">android@forexcalcs.com</a></p>  
    </NoteContainer>
  );
}

export default TermsOfUse;